import { portalPaths } from './paths';
// mapping of old routes to new routes for redirection
// add entries here when making changes to routes to redirect outdated urls
// this helps users reach the correct pages instead of getting 404 errors
export const LEGACY_ROUTES_MAPPING = {
    '/service-desk/conversations/:conversationId': portalPaths.conversation.allSelected(':conversationId'),
    '/service-desk/conversations': portalPaths.entity.all({
        entityName: 'conversations',
    }),
    '/settings/membershipsV2': portalPaths.settings.memberships(),
    '/settings/membershipsV2/*': portalPaths.settings.memberships(),
    '/settings/stripe': portalPaths.settings.billing(),
    '/settings/stripe/*': portalPaths.settings.billing(),
};
